import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import { formikFormShape } from '../prop-types';


class FormLanguageSelector extends Component {
  render() {
    const {
      field, form: { touched, errors }, ...rest
    } = this.props;
    const displayError = touched[field.name] && errors[field.name];
    return (
      <React.Fragment>
        <div>
          <div className="p-inputgroup">
            <Dropdown
              {...field}
              {...rest}
              filter
              className={displayError ? 'p-error' : ''}
            />
          </div>
        </div>
        <ErrorMessage name={field.name} component="div" />
      </React.Fragment>
    );
  }
}
FormLanguageSelector.propTypes = {
  form: formikFormShape.isRequired,
  field: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FormLanguageSelector;
